import { LocalPreferenceKeys, localPreferences } from "./LocalPreferences";
import { switchEnv } from "gather-env-config/dist/src/public/env";
import { ErrorContext } from "gather-common/dist/src/public/utils";
import { Logger } from "./Logger";
export const getSelectedLanguageSetting = () => localPreferences.get(LocalPreferenceKeys.SelectedLanguage);
export const getNavigatorLanguage = () => typeof navigator !== "undefined" ? navigator?.language : "";
export const getSelectedOrRawLocale = () => {
    const selectedLanguage = getSelectedLanguageSetting();
    const navigatorLanguage = getNavigatorLanguage();
    return selectedLanguage || navigatorLanguage;
};
export const tAsString = (result) => {
    if (typeof result !== "string") {
        switchEnv({
            test: null,
            local: () => Logger.error(`t() was called with wrong format for key`, new ErrorContext({ result: result.toString() })),
            dev: null,
            staging: null,
            prod: null,
        });
        return "wrong key";
    }
    return result;
};
//# sourceMappingURL=i18n.js.map